<template>
  <div class="key-frame">
    <display-tag v-for="(waypointToDisplay, index) in waypointsToDisplay"
      :key="waypointToDisplay.wp.id + index" 
      :waypointToDisplay="waypointToDisplay" 
      :hasFocus="waypointToDisplay.wp.id === focusedWaypointId"
      :isSelected="isSelected(waypointToDisplay)"
      @askFocus="onAskFocus"
      @releaseFocus="onReleaseFocus"
      @waypointSelect="(waypoint) => $emit('waypointSelect', waypoint)" 
      @waypointMove="(event) => $emit('waypointMove', event)"
      @waypointResize="(event) => $emit('waypointResize', event)"
      @waypointDelete="(waypoint) => $emit('waypointDelete', waypoint)"
      @waypointCreate="(waypoint) => $emit('waypointCreate', waypoint)"
      @applySizeAndPosition="(waypoint) => $emit('applySizeAndPosition', waypoint)"/>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import displayTag from './displayTag'
import guid from '../../../utils/guid'
import { getFilter } from '../../../utils/filters'

export default {
  name: 'keyFrame',

  components: {
    'display-tag' : displayTag
  },

  data() {
    return {
      focusedWaypointId: ''
    }
  },

  computed: {
    ...mapState(['keyFrame']),
    ...mapGetters(['currentTime', 'getAllScenesByTags']),

    waypointsToDisplay: function () {
      let activeScenes = []
      let waypointsToDisplay = []

      activeScenes = this.getAllScenesByTags(getFilter('1'))

      activeScenes = activeScenes.reverse().filter(as => {
        return this.isTimeInScene(this.currentTime, as.scene)
      })

      waypointsToDisplay = activeScenes.map(as => {
        return this.getWaypointToDisplay(as.tag, as.scene, this.currentTime)
      })

      return waypointsToDisplay
    }
  },

  methods: {
    isSelected: function (waypointToDisplay) {
      const isSelected = this.keyFrame.selectedWaypoints.some(swp => {
        return swp.wp === waypointToDisplay.wp
      })

      return isSelected
    },

    isTimeInScene: function (time, scene) {
      const waypoints = [...scene.waypoints].sort((a,b) => a.time - b.time)
      const sceneStartTime = parseFloat(waypoints[0].time.toFixed(2))
      const sceneEndTime = parseFloat(waypoints[waypoints.length - 1].time.toFixed(2))

      time = parseFloat(time.toFixed(2))

      return sceneStartTime <= time && sceneEndTime >= time
    },

    onAskFocus: function (waypoint) {
      if (!this.focusedWaypointId) {
        this.focusedWaypointId = waypoint.id
      }
    },

    onReleaseFocus: function (waypoint) {
      if (this.focusedWaypointId === waypoint.id) {
        this.focusedWaypointId = ''
      }
    },

    getWaypointToDisplay: function (tag, scene, time) {
      const waypoints = [...scene.waypoints].sort((a,b) => a.time - b.time)

      let waypointToDisplay
      let waypoint = {}
      let isActive = true

      waypoints.forEach(wp => {
        if(wp.time.toFixed(2) === time.toFixed(2)) {
          waypoint = wp
        }
      })

      if(!waypoint.id) {
        waypoint = this.extrapolateWaypoint(scene, time)
        isActive = false
      }

      waypointToDisplay = {
        wp: waypoint,
        tag: tag,
        scene: scene,
        time: time,
        isActive: isActive
      }

      return waypointToDisplay
    },

    extrapolateWaypoint: function (scene, time) {
      const waypoints = scene.waypoints

      let start = waypoints[0]
      let end = waypoints[waypoints.length - 1]

      waypoints.reverse().forEach((wp) => {
        if (wp.time >= time) {
          end = wp
        }
      })

      waypoints.reverse().forEach((wp) => {
        if (wp.time <= time) {
          start = wp
        }
      })

      const deltaTime = end.time - start.time
      const deltaX = end.x - start.x
      const deltaY = end.y - start.y
      const deltaH = end.h - start.h
      const deltaW = end.w - start.w
      const deltaPH = end.ph - start.ph
      const deltaPW = end.pw - start.pw

      const relativeTime = (time - start.time) / deltaTime

      const x = start.x + (deltaX * relativeTime)
      const y = start.y + (deltaY * relativeTime)
      const h = start.h + (deltaH * relativeTime)
      const w = start.w + (deltaW * relativeTime)
      const ph = start.ph + (deltaPH * relativeTime)
      const pw = start.pw + (deltaPW * relativeTime)

      return {
        time: time,
        x: x,
        y: y,
        w: w,
        h: h,
        ph: ph,
        pw: pw,
        id: guid()
      }
    }
  }
}
</script>
